export default __webpack_public_path__ + "static/media/DotIcon.11f3d627.svg";